import { IconCast } from "@tabler/icons-react"
import { SVGProps } from "react"

import { IconProps } from "../icon.types"

export const IconCommunicationStudio = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <IconCommunicationStudioHovered {...props} />
  else {
    return <IconCast {...props} />
  }
}

const IconCommunicationStudioHovered = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="var(--mantine-color-primary-4)"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="currentColor"
    {...props}
  >
    <rect
      x="0"
      y="0"
      width="24"
      height="24"
      rx="4"
      ry="4"
      stroke="currentColor"
    />
    <path d="M7 19a4 4 0 0 0 -4 -4" />
    <path d="M11 19a8 8 0 0 0 -8 -8" />
    <path d="M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2" />
  </svg>
)
